import { ChangeEvent, Dispatch, SetStateAction, useCallback, useState } from 'react'

export const useNumericalString = (
  initialState = ''
): {
  state: string
  handleState: (event: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>) => void
  setState: Dispatch<SetStateAction<string>>
  error: string
  setError: Dispatch<SetStateAction<string>>
} => {
  const [state, setState] = useState<string>(initialState)
  const [error, setError] = useState<string>('')
  const handleState = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const value = event.target.value
      if (!/^[0-9]*$/.test(value)) return
      setState(value)
    },
    [setState]
  )
  return { state, handleState, setState, error, setError }
}

export default useNumericalString
